import styles from "./Footer.module.css"

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <p className={styles.text}>
          &copy; 2026 Evan King &middot; Built with React
        </p>
      </div>
    </footer>
  )
}
